import {createFileRoute} from "@tanstack/react-router";

import {materialDetailMessages} from "../../-messages/material-detail.messages";
import {MaterialCompositionPage} from "./-page/material-composition.page";

export const Route = createFileRoute("/_app/engineering/materials/$materialId/composition/")({
  component: RouteComponent,
  staticData: {meta: {labelDescriptor: materialDetailMessages.composition}},
});

function RouteComponent() {
  const {materialId} = Route.useParams();
  const {includeDeleted} = Route.useSearch();

  return <MaterialCompositionPage materialId={materialId} includeDeleted={includeDeleted} />;
}
